import {Component, HostBinding, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ModalAction} from "./index";
import {Helpers} from "../helpers";
import {stat} from "ng-packagr/lib/utils/fs";

@Component({
  selector: 'modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {

  @Input() @HostBinding('class.active') active: boolean = false;
  @Input() heading = "";
  @Input() height:number | undefined;
  @Input() width:number | undefined;
  @Input() actions: ModalAction[] = [];
  @Input() loading = false;
  @Input() disable_exit = false;
  toggle(){
    if(!this.disable_exit){
      this.active = !this.active;
    }
  }
  set_state(state:boolean){
    this.active = state;
  }
  toggle_loading(){
    this.loading = !this.loading;
  }

  async actionFunc(action: ModalAction) {
    const label = action.label;

    if (action.label && action.loading_label) {
      action.label = action.loading_label;
    }

    this.toggle_loading()
    await action.func();
    this.toggle_loading()

    if (action.label && action.loading_label) {
      action.label = label;
    }

    this.toggle();
  }


}



